import { FC, createContext, ReactNode, useContext } from "react";
import { SSROptionsKeys, SSROptionsType } from "src/Modules/Flights/constants/JourneyDetails";

export type SSRCursor = {
  flightId: string | undefined;
  passengerId: string | undefined;
  ssrType?: SSROptionsKeys;
};

type SSRContextValue = {
  cursor: SSRCursor;
  handleChange:(id:keyof SSRCursor,value:string)=> ()=>void;
  flightOptions:any[];
  passengerOptions: any[];
  SSROptions: SSROptionsType[];
  getSSRItem: (type?: SSROptionsKeys,passengerId?:string) => any;
  updateSSRItem: (type:SSROptionsKeys, value: any) => void;
};

const SSRContext = createContext<SSRContextValue | null>(null);

const SSRContextProvider: FC<{ value: SSRContextValue; children: ReactNode }> = ({ value, children }) => {
  return <SSRContext.Provider value={value}>{children}</SSRContext.Provider>;
};

const useSSRContext = () => {
  const context = useContext(SSRContext);
  if (!context) throw new Error("Illegal usage of SSRContext");
  return context;
};

export { useSSRContext, SSRContextProvider };
